import { Trans } from '@lingui/macro'
import { AddLocationAltOutlined, CalendarMonthOutlined, ContentPasteSearchOutlined, ExploreOutlined, HomeOutlined, HowToVoteOutlined, InventoryOutlined, LocalLibraryOutlined, PaidOutlined } from '@mui/icons-material'
import { authRoles, hasRole } from './auth/authRoles'
import sfOauthConfig, {
  chtcEnvs,
  internalEnvs,
  nonInternalEnvs
} from './services/sfAuth/sfAuthConfig'
import { FUNDING_PATHS } from './views/funding/FundingRoutes'
import { resourceInventoryPaths } from './views/resources/ResourceRoutes'
import { SAT_PATHS } from './views/self-assessment/SATRoutes'

export const navigations = [
  {
    name: <Trans>GRANTS_ROUTES_HOMEPAGE_LABEL</Trans>,
    datatut: 'reactour__sidenav__homepage',
    icon: <HomeOutlined className='nav-item-icon' />,
    path: '/grants/home'
  },
  {
    name: <Trans>NAVIGATIONS_APPLY_FOR_FUNDING</Trans>,
    icon: <PaidOutlined className='nav-item-icon' />,
    path: '/grants/apply',
    functionPermissions: [
      ({ user, organization }) => {
        if (organization && organization.id) {
          return false
        }
        return !sfOauthConfig.isInternal
      }
    ]
  },
  {
    name: <Trans>NAVIGATIONS_FUNDING</Trans>,
    icon: <PaidOutlined className='nav-item-icon' />,
    path: '/grants/apply',
    env: nonInternalEnvs,
    functionPermissions: [
      ({ user, organization }) => {
        if (organization && organization.id) {
          return true
        }
        return false
      }
    ],
    children: [
      {
        name: <Trans>NAVIGATIONS_ORGANIZATION_DETAILS</Trans>,
        datatut: 'reactour__sidenav__organization',
        auth: authRoles.grantee,
        path: '/grants/organization-details'

      },
      {
        name: <Trans>NAVIGATIONS_APPLICATIONS</Trans>,
        datatut: 'reactour__sidenav__applicationlist',
        path: FUNDING_PATHS.APPLICATIONS_LIST,
        auth: authRoles.grantee
      },
      {
        name: <Trans>NAVIGATIONS_GRANTEE_REPORTS</Trans>,
        path: '/grants/Reports',
        // env: chtcEnvs,
        auth: authRoles.grantee
      }
    ]
  },
  {
    name: <Trans>NAVIGATIONS_COMPLETE_ORGANIZATIONAL_COMPASS</Trans>,
    icon: <ExploreOutlined className='nav-item-icon' />,
    path: SAT_PATHS.SAT_LANDING,
    env: nonInternalEnvs,
    auth: authRoles.grantee,
    functionPermissions: [
      ({ user, organization }) => {
        if (organization && organization.id) {
          return false
        }
        return true
      }
    ]
  },
  {
    name: <Trans>NAVIGATIONS_ORGANIZATIONAL_COMPASS</Trans>,
    icon: <ExploreOutlined className='nav-item-icon' />,
    path: SAT_PATHS.SAT_LANDING,
    env: nonInternalEnvs,
    auth: authRoles.grantee,
    functionPermissions: [
      ({ user, organization }) => {
        if (organization && organization.id) {
          return true
        }
        return false
      }
    ],
    children: [
      {
        name: <Trans>NAVIGATIONS_ASSESSMENTS</Trans>,
        path: SAT_PATHS.MY_ASSESSMENTS,
        env: chtcEnvs,
        auth: authRoles.grantee
      },
      {
        name: <Trans>NAVIGATIONS_ACTION_PLAN</Trans>,
        path: '/grants/ActionPlan',
        env: chtcEnvs,
        auth: authRoles.grantee
      }
    ]
  },
  {
    name: <Trans>NAVIGATIONS_RESOURCES</Trans>,
    icon: <LocalLibraryOutlined className='nav-item-icon' />,
    path: resourceInventoryPaths.resourceInventory,
    auth: authRoles.grantee,
    children: [
      {
        name: <Trans>NAVIGATIONS_MY_SHELF</Trans>,
        path: resourceInventoryPaths.resourceInventoryMyShelf,
        env: nonInternalEnvs,
        auth: authRoles.grantee
      },
      {
        name: <Trans>NAVIGATIONS_MY_RESOURCE_ENTRIES</Trans>,
        path: resourceInventoryPaths.resourceInventoryMyEntries,
        env: nonInternalEnvs,
        auth: authRoles.grantee
      }
    ]
  },
  {
    name: <Trans>NAVIGATIONS_EXTERNAL_REVIEWER</Trans>,
    icon: <ContentPasteSearchOutlined className='nav-item-icon' />,
    env: chtcEnvs,
    auth: authRoles.reviewer,
    functionPermissions: [
      ({ user, organization }) => {
        return (
          hasRole(user.role, authRoles.reviewer) &&
          user.hasExternalReviewProfile
        )
      }
    ],
    children: [
      {
        name: <Trans>NAVIGATIONS_REVIEWER_PROFILE</Trans>,
        path: '/grants/reviewer-profile'
      },
      {
        name: <Trans>NAVIGATIONS_ASSIGNED_REVIEWS</Trans>,
        path: '/grants/assigned-reviews',
        auth: authRoles.reviewer
      }
    ]
  },
  {
    name: <Trans>NAVIGATIONS_BECOME_EXTERNAL_REVIEWER</Trans>,
    path: '/grants/apply-to-external-reviewer',
    icon: <ContentPasteSearchOutlined className='nav-item-icon' />,
    env: nonInternalEnvs,
    auth: authRoles.grantee,
    functionPermissions: [
      ({ user, organization }) => {
        return (
          !hasRole(user.role, authRoles.reviewer) ||
          !user.hasExternalReviewProfile
        )
      }
    ]
  },
  {
    name: <Trans>NAVIGATIONS_CALENDAR</Trans>,
    icon: <CalendarMonthOutlined className='nav-item-icon' />,
    env: chtcEnvs,
    path: '/calendar',
    auth: authRoles.grantee
  },
  // {
  //   name: <Trans>Work Groups</Trans>,
  //   iconText: 'NI',
  //   path: '/grants/Committees',
  //   auth: authRoles.workgroupMember
  // },
  {
    name: <Trans>NAVIGATIONS_APPLICATION_LIST</Trans>,
    iconText: 'NI',
    path: '/internal/ProgramManagerApplicationList',
    env: internalEnvs,
    icon: <PaidOutlined className='nav-item-icon' />,
    auth: authRoles.pm
  },
  // {
  //   name: <Trans>Environmental - Self Assessment Tool</Trans>,
  //   path: '/surveys/ESAT',
  //   env: chtcEnvs,
  //   iconText: 'NI',
  //   auth: authRoles.grantee
  // },
  {
    name: <Trans>VVIVRE_EN_VILLE_NAVBAR_TAB</Trans>,
    icon: <AddLocationAltOutlined className='nav-item-icon' />,
    auth: authRoles.vivre_en_ville,
    children: [
      {
        name: <Trans>VIVRE_EN_VILLE_MAP</Trans>,
        path: '/vivre-en-ville/map',
        auth: authRoles.vivre_en_ville
      },
      {
        name: <Trans>VIVRE_EN_VILLE_RENTS_TAB</Trans>,
        path: '/vivre-en-ville/rents',
        auth: authRoles.vivre_en_ville
      }
    ]
  },
  // {
  //   name: <Trans>Technical Advisories</Trans>,
  //   iconText: 'NI',
  //   env: icceEnvs,
  //   path: '/grants/TechnicalAdvisories',
  //   auth: authRoles.technicalAdvisory
  // },
  // {
  //   name: <Trans>Technical Advisory Ranking</Trans>,
  //   iconText: 'NI',
  //   env: icceEnvs,
  //   path: '/internal/TechnicalAdvisoryRanking',
  //   auth: authRoles.pm
  // },
  {
    name: <Trans>DMAH_TAB</Trans>,
    icon: <InventoryOutlined className='nav-item-icon' />,
    path: '/dmah/applications',
    auth: authRoles.DMAH
  },
  {
    name: <Trans>NAVIGATIONS_ALLOCATION_COMMITTEE</Trans>,
    icon: <HowToVoteOutlined className='nav-item-icon' />,
    env: chtcEnvs,
    auth: authRoles.allocationCommittee,
    inOneOfGroups: ['Allocation_Committee', 'Directors_Admin'],
    children: [
      {
        name: <Trans>NAVIGATIONS_EXECUTIVE_SUMMARIES</Trans>,
        path: '/grants/committee/ac',
        auth: authRoles.allocationCommittee
        // inOneOfGroups: ['Allocation_Committee', 'Directors_Admin']
      },
      {
        name: <Trans>NAVIGATIONS_MEETINGS</Trans>,
        path: '/grants/Meetings/AC',
        auth: authRoles.allocationCommittee
        // inOneOfGroups: ['Allocation_Committee', 'Directors_Admin']
      }
    ]
  },
  {
    name: <Trans>NAVIGATIONS_SELECTION_COMMITTEE</Trans>,
    icon: <HowToVoteOutlined className='nav-item-icon' />,
    env: chtcEnvs,
    auth: authRoles.selectionCommittee,
    children: [
      {
        name: <Trans>NAVIGATIONS_EXECUTIVE_SUMMARIES</Trans>,
        path: '/grants/executive-summaries/SC',
        auth: authRoles.selectionCommittee
      },

      {
        name: <Trans>NAVIGATIONS_SC_MEETINGS</Trans>,
        path: '/grants/Meetings/SC',
        inOneOfGroups: [
          'SC_NSCHGF_Capacity_Building',
          'SC_NSCHGF_Planning_Pre_Development',
          'SC_NSCHGF_Research_Innovation',
          'Directors_Admin'
        ]
      },
      {
        name: <Trans>SELECTION_COMMITTEE_NUNAVUT_MEETINGS_TAB_TITLE</Trans>,
        path: '/grants/Meetings/SC-NPF',
        inOneOfGroups: [
          'SC_NPF_Planning_Pre_Development',
          'SC_NPF_Capacity_Building',
          'SC_NPF_Research_Innovation',
          'Directors_Admin'
        ]
      },
      {
        name: <Trans>SELECTION_COMMITTEE_CHGFB3_MEETINGS_TAB_TITLE</Trans>,
        path: '/grants/Meetings/SC-CHGFB3',
        inOneOfGroups: [
          'SC_NSBCHF_Capacity_Building',
          'SC_NSBCHF_Planning_Pre_Development',
          'SC_NSBCHF_Research_Innovation',
          'Directors_Admin'
        ]
      },
      {
        name: <Trans>SELECTION_COMMITTEE_NLGF_MEETINGS_TAB_TITLE</Trans>,
        path: '/grants/Meetings/NLGF',
        inOneOfGroups: [
          'SC_NLCHGF_Planning_Pre_Development',
          'Directors_Admin'
        ]
      }
    ]
  },
  {
    name: <Trans>GRANTS_ROUTES_BOARD_EXECUTIVE_SUMMARIES_LABEL</Trans>,
    icon: <HowToVoteOutlined className='nav-item-icon' />,
    env: chtcEnvs,
    path: '/grants/committee/board',
    auth: authRoles.board
  },
  {
    name: <Trans>GRANTS_ROUTES_CMHC_EXECUTIVE_SUMMARIES_LABEL</Trans>,
    icon: <HowToVoteOutlined className='nav-item-icon' />,
    env: chtcEnvs,
    path: '/grants/committee/cmhc',
    auth: authRoles.cmhc
  },

  {
    name: <Trans>NAVIGATIONS_ADMINISTRATOR</Trans>,
    iconText: 'NI',
    auth: authRoles.translator,
    children: [
      {
        name: <Trans>ACTIVE_EDITING_SESSIONS</Trans>,
        path: '/internal/active-sessions',
        auth: authRoles.admin
      },
      {
        name: <Trans>NAVIGATIONS_CONFIGURABLE_FORM_URLS</Trans>,
        path: '/internal/create-form-preview-url',
        auth: authRoles.editor
      },
      {
        name: <Trans>NAVIGATION_GENERATE_PDF_FOR_APPLICATION_FORM</Trans>,
        path: '/internal/generate-pdf-for-application',
        auth: authRoles.admin
      },
      {
        name: <Trans>INTERNAL_ROUTES_CONFIGURE_USER_PERMISSIONS_LABEL</Trans>,
        path: '/internal/ConfigureUserPermissions',
        auth: authRoles.admin
        // env: internalEnvs,
      },
      {
        name: <Trans>INTERNAL_ROUTES_CONFIGURE_FUNDING_STREAMS_LABEL</Trans>,
        path: '/internal/ConfigureFundingStreams',
        auth: authRoles.admin
        // env: internalEnvs,
      },
      {
        name: <Trans>INTERNAL_ROUTES_PORTAL_CONFIGURATIONS_LABEL</Trans>,
        path: '/internal/PortalConfigurations',
        auth: authRoles.admin
        // env: internalEnvs,
      },
      {
        name: <Trans>INTERNAL_ROUTES_EXPORT_SURVEYS_LABEL</Trans>,
        path: '/internal/ExportSurveys',
        auth: authRoles.admin,
        env: internalEnvs
      },
      {
        name: <Trans>FORMS_ROUTES_FORMS_LABEL</Trans>,
        path: '/internal/Forms',
        auth: authRoles.pm
      },
      {
        name: <Trans>SURVEY_ROUTES_SURVEY_SCORE_LABEL</Trans>,
        path: '/surveys/SurveyTemplates',
        auth: authRoles.editor
      },
      {
        name: <Trans>SURVEY_ROUTES_SCORE_CARDS_LABEL</Trans>,
        path: '/surveys/ScoreCards',
        auth: authRoles.admin
      },
      // {
      //   name: <Trans>Variables</Trans>,
      //   path: '/grants/Variables',
      //   auth: authRoles.admin,
      //   iconText: 'V'
      // },
      // {
      //   name: <Trans>Export/Impor<Trans>,
      //   path: '/internal/ExportImportObjects',
      //   env: chtcEnvs,
      //   auth: authRoles.admin,
      //   iconText: 'E'
      // },
      {
        name: <Trans>INTERNAL_ROUTES_TRANSLATIONS_EDITOR_LABEL</Trans>,
        path: '/internal/TranslationsEditor',
        auth: authRoles.translator
      },
      {
        name: <Trans>PAGE_TRANSLATIONS</Trans>,
        path: '/internal/page-translations',
        auth: authRoles.admin
      },
      {
        name: <Trans>GRANTS_ROUTES_ACTION_TEMPLATES_LABEL</Trans>,
        env: chtcEnvs,
        path: '/grants/ActionTemplates',
        auth: authRoles.editor
      },
      {
        name: <Trans>NAVIGATIONS_SERVICE_INVENTORY</Trans>,
        env: chtcEnvs,
        path: '/grants/ServiceInventory',
        auth: authRoles.admin
      }
    ]
  }
]
